<script>
export default {
  name: 'view-shipping-card',
  props: {
    shippingAddress: {
      type: Object
    }
  }
}
</script>
<template>
  <b-card no-body>
    <b-card-body>
      <b-row no-gutters align-v="start" align-h="start">
        <i class="mdi mdi-cube-send font-size-16 mr-4" />
        <template v-if="!!shippingAddress">
          <div
            class="d-flex flex-column justify-content-start align-items-start"
          >
            <h6 class="text-truncate mb-1">
              {{ $t('ship to') }}
            </h6>
            <p class="text-truncate m-0">
              {{ shippingAddress.company_name }}<br />
              {{ shippingAddress.street }} {{ shippingAddress.number }},<br />
              {{ shippingAddress.country_code }}-{{ shippingAddress.zipcode }}
              {{ shippingAddress.city }}
            </p>
          </div>
        </template>
        <template v-else>
          <h6 class="text-truncate m-0">
            {{ $t('no shipping') }}
          </h6>
        </template>
      </b-row>
    </b-card-body>
  </b-card>
</template>
